import React from 'react';
import LanguageToggle from '../navigation/LanguageToggle';
import { useLanguage } from '../../../shared/contexts/LanguageContext';
import PoweredByFooter from '../feedback/PoweredByFooter';

interface ScreenLayoutProps {
  children: React.ReactNode;
  onBack?: () => void;
  showBackButton?: boolean;
  showLanguageToggle?: boolean;
  className?: string;
  centerContent?: boolean;
}

const ScreenLayout: React.FC<ScreenLayoutProps> = ({ 
  children, 
  onBack,
  showBackButton = false,
  showLanguageToggle = true,
  className = '',
  centerContent = false
}) => {
  const { isRTL } = useLanguage();

  return (
    <div className={`screen-layout h-screen relative ${className}`} style={{ backgroundColor: '#cdc7c7' }}>
      {/* Language Toggle - Now handled by LogoutButton component */}
      {/* {showLanguageToggle && <LanguageToggle />} */}

      {/* Back Button */}
      {showBackButton && onBack && (
        <div className="fixed top-0 left-0 right-0 self-stretch flex justify-between px-[32px] py-[24px] z-10 bg-[#cdc7c7]">
          <button 
            className="text-[#2e5d7d] text-[16px] font-normal hover:underline flex items-center gap-2" 
            onClick={onBack}
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              className={isRTL ? 'rotate-180' : ''}
            >
              <path d="M15.5 19l-7-7 7-7" />
            </svg>
            <span>{isRTL ? 'رجوع' : 'Back'}</span>
          </button>
        </div>
      )}
      
      {/* Content Area */}
      <div
        className={`
          content-area
          ${showBackButton ? 'pt-20' : 'pt-4'}
          pb-4 sm:px-4 px-0 h-full
          flex flex-col items-center sm:items-center ${centerContent ? 'justify-center' : 'sm:justify-center justify-start'}
          ${isRTL ? 'font-arabic' : ''}
        `}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        {children}
        {/* Powered by footer placed directly under main content */}
        <PoweredByFooter className="mt-6" />
      </div>
    </div>
  );
};

export default ScreenLayout; 